/* app/js/src/components/common/alert/alert.component.scss */
.alert-curtain {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 10;
  display: none;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.alert-curtain section {
  background-color: #ffffff;
  border: 1px solid #e1e6eb;
  position: absolute;
  width: 35vw;
  text-align: center;
  border-radius: 4px;
  padding: 2vw 1vw;
  display: none;
  animation: enter 0.3s forwards;
  -webkit-animation: enter 0.3s forwards;
  -webkit-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
}
.cursor-pointer {
  cursor: pointer;
}
:host {
  position: fixed;
  z-index: 999999999999999;
}
.alert-curtain section {
  max-width: 80vw;
}
.alert-curtain section > a {
  position: absolute;
  top: 1vw;
  right: 0.5vw;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}
.alert-curtain section > a svg {
  display: block;
  width: 20px;
  height: 20px;
  fill: #879baf;
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  -ms-transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: transform 0.2s ease;
  transition: transform 0.2s ease;
}
.alert-curtain section > a:hover svg {
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.alert-curtain section h4 {
  margin: 0;
  font-size: 1.5em;
  font-weight: 100;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  color: #232f3a;
}
.alert-curtain section p {
  margin-top: 19px;
  margin-bottom: 22px;
  color: #232f3a;
}
.alert-curtain section .progress-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 80px;
  margin: 19px 0 22px;
}
.alert-curtain section .progress-area .progress-spinner {
  width: 28px;
  height: 28px;
  border: 2px solid rgba(35, 47, 58, 0.15);
  border-top-color: #232f3a;
  border-radius: 50%;
  animation: progressSpin 0.8s linear infinite;
  margin-bottom: 16px;
}
.alert-curtain section .progress-area .progress-message {
  margin: 0;
  opacity: 0;
  transition: opacity 0.25s ease;
  text-align: center;
  color: #232f3a;
}
.alert-curtain section .progress-area .progress-message.message-visible {
  opacity: 1;
}
.alert-curtain section .progress-area .loading-dots {
  display: inline-block;
  width: 1.2em;
  text-align: left;
}
.alert-curtain section .progress-area .loading-dots span {
  opacity: 0.2;
  animation: dotPulse 1.2s infinite;
}
.alert-curtain section .progress-area .loading-dots span:nth-child(1) {
  animation-delay: 0s;
}
.alert-curtain section .progress-area .loading-dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.alert-curtain section .progress-area .loading-dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.alert-curtain section .options {
  list-style-type: none;
  text-align: left;
}
.alert-curtain section .options li {
  cursor: pointer;
  margin-bottom: 10px;
  font-size: 18px;
}
.alert-curtain section .options li input {
  margin-right: 30px;
  cursor: pointer;
}
.alert-curtain section .options li span {
  font-weight: bold;
}
.alert-curtain section button {
  background-color: #232f3a;
  color: #ffffff;
  border-radius: 4px;
  border: none;
  padding: 6px 25px;
}
.alert-curtain ichannel-button {
  margin: 0 5px;
}
.alert-curtain.alertActive {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.alert-curtain.alertActive section {
  display: block;
}
@keyframes progressSpin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes dotPulse {
  0%, 80%, 100% {
    opacity: 0.2;
  }
  40% {
    opacity: 1;
  }
}
/*# sourceMappingURL=alert.component.css.map */
